import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

// Simple alias for trans => translate
@Pipe({ name: 'trans', pure: false })
export class TransPipe extends TranslatePipe implements PipeTransform { }
